"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var Context = /*#__PURE__*/function () {
  function Context(config) {
    this.config = config;
    this.rumEvent = void 0;
    this.views = [];
  }
  var _proto = Context.prototype;
  _proto.getConfig = function getConfig() {
    return this.config;
  };
  _proto.setConfig = function setConfig(config) {
    this.config = config;
  };
  _proto.getViews = function getViews() {
    return this.views;
  };
  _proto.addView = function addView(view) {
    this.views.push(view);
  };
  _proto.removeView = function removeView(viewId) {
    this.views = this.views.filter(function (view) {
      return view.id !== viewId;
    });
  };
  _proto.getRumEvent = function getRumEvent() {
    return this.rumEvent;
  };
  _proto.setRumEvent = function setRumEvent(rumEvent) {
    this.rumEvent = rumEvent;
  };
  return Context;
}();
var _default = exports["default"] = Context;